import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useFetch } from "../hooks/useFetch";
import LanguageDetect from "languagedetect";
import { countries } from "../data/countries";

const langdetect = new LanguageDetect();

export default function Notification(params) {
  const { Fetch } = useFetch();

  const [message, setmessage] = useState("");
  const [audienceType, setAudienceType] = useState("all");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");

  const canSendByAudience =
    audienceType === "all" ||
    audienceType === "direct_all" ||
    (audienceType === "country" && !!selectedCountry) ||
    (audienceType === "language" && !!selectedLanguage);
  const canSend = canSendByAudience && !!message.trim();

  const countryOptions = Object.entries(countries)
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));

  function detectTextDirection(text) {
    const detectedLanguage = langdetect.detect(text, 1);
    return detectedLanguage.length && detectedLanguage[0][0] === "arabic"
      ? "rtl"
      : "ltr";
  }

  useEffect(() => {
    console.log("Audience Type:", audienceType);
  }, [audienceType]);

  useEffect(() => {
    console.log("Selected Country:", selectedCountry);
  }, [selectedCountry]);

  useEffect(() => {
    console.log("Selected Language:", selectedLanguage);
  }, [selectedLanguage]);

  return (
    <div>
      <Dialog
        open={params.open}
        onClose={close_message_dialog}
        fullWidth={useState("md")}
      >
        <DialogContent>
          <DialogContentText style={{ fontSize: "20px" }}>
            Send a notification to users
          </DialogContentText>

          <FormControl component="fieldset" style={{ marginTop: "18px" }}>
            <FormLabel component="legend">Audience</FormLabel>
            <RadioGroup
              row
              value={audienceType}
              onChange={(e) => setAudienceType(e.target.value)}
            >
              <FormControlLabel value="all" control={<Radio />} label="All" />
              <FormControlLabel
                value="direct_all"
                control={<Radio />}
                label="All (direct tokens)"
              />
              <FormControlLabel
                value="country"
                control={<Radio />}
                label="Country"
              />
              <FormControlLabel
                value="language"
                control={<Radio />}
                label="Language"
              />
            </RadioGroup>
          </FormControl>

          {audienceType === "country" && (
            <FormControl fullWidth style={{ marginTop: "10px" }}>
              <InputLabel id="country-select">Country</InputLabel>
              <Select
                labelId="country-select"
                value={selectedCountry}
                label="Country"
                onChange={(e) => setSelectedCountry(e.target.value)}
              >
                {countryOptions.map((country) => (
                  <MenuItem key={country.code} value={country.code}>
                    {country.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {audienceType === "language" && (
            <FormControl fullWidth style={{ marginTop: "10px" }}>
              <InputLabel id="language-select">Language</InputLabel>
              <Select
                labelId="language-select"
                value={selectedLanguage}
                label="Language"
                onChange={(e) => setSelectedLanguage(e.target.value)}
              >
                <MenuItem value="En">English</MenuItem>
                <MenuItem value="Ar">Arabic</MenuItem>
                <MenuItem value="Es">Spanish</MenuItem>
                <MenuItem value="tr">Turkish</MenuItem>
              </Select>
            </FormControl>
          )}
          <TextField
            autoFocus
            margin="dense"
            placeholder="Message"
            label="Message"
            id="message"
            onChange={(e) => {
              setmessage(e.target.value);
            }}
            value={message}
            type="text"
            fullWidth={useState("md")}
            variant="standard"
            multiline
            rows={4}
            maxRows={Infinity}
            dir={detectTextDirection(message)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={close_message_dialog}>Close</Button>
          <Button onClick={send} disabled={!canSend}>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

  function close_message_dialog() {
    params.onClose();
  }

  async function send() {
    if (!canSend) {
      return;
    }

    if (audienceType === "direct_all") {
      await Fetch("post", "users/notification", {
        message: message,
        broadcastAll: true,
      });

      setmessage("");
      setAudienceType("all");
      setSelectedCountry("");
      setSelectedLanguage("");
      params.onSend();
      return;
    }

    let topic = "all_users";
    if (audienceType === "country") {
      topic = `country_${String(selectedCountry).toLowerCase()}`;
    }
    if (audienceType === "language") {
      topic = `language_${String(selectedLanguage).toLowerCase()}`;
    }

    await Fetch("post", "users/notification", {
      message: message,
      topic,
    });

    setmessage("");
    setAudienceType("all");
    setSelectedCountry("");
    setSelectedLanguage("");
    params.onSend();
  }
}
